import React from "react";

import Styles from "./TitleAndText.module.css";

const TitleAndText = (props) => {

  return (
    <div className={Styles["TitleAndText"]}>
      <div className="row">
        <div className={`col-xs-12 ${Styles["title"]}`}>{props.title}</div>
        <div className={`col-xs-12 ${Styles["text"]}`}>{props.text}</div>
      </div>
    </div>
  );
};

export default TitleAndText;
